import React from 'react';
import { motion } from 'framer-motion';
import GlobalSearch from './GlobalSearch';
import './HeroBanner.css';

const HeroBanner = ({ images, currentImage = 0, onImageChange }) => {
  return (
    <section className="hero-banner">
      <div className="hero-slideshow">
        {images.map((img, index) => (
          <motion.div
            key={index}
            className={`hero-slide ${index === currentImage ? 'active' : ''}`}
            initial={{ opacity: 0 }}
            animate={{ opacity: index === currentImage ? 1 : 0 }}
            transition={{ duration: 1 }}
            style={{
              backgroundImage: `url(${img})`,
            }}
          />
        ))}
        <div className="hero-overlay" />
      </div>

      <div className="hero-content">
        <motion.div
          className="hero-text"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h1 className="hero-title">Find your perfect stay</h1>
          <h2 className="hero-subtitle-large">
            <span className="gradient-text">Anywhere. Anytime. Comfort guaranteed</span>
          </h2>
        </motion.div>
      </div>

      <div className="hero-search-section">
        <GlobalSearch />
      </div>

      {images.length > 1 && (
        <div className="hero-indicators">
          {images.map((_, index) => (
            <button
              key={index}
              type="button"
              className={`hero-indicator-dot no-min-touch ${index === currentImage ? 'active' : ''}`}
              aria-label={`Image ${index + 1}`}
              onClick={() => onImageChange && onImageChange(index)}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default HeroBanner;


